import { NgModule } from '@angular/core';
import { OrderreviewRoutingModule } from './orderreview-routing.module';
import { ProductviewlistComponent } from './productviewlist.component';
import { OrderaddupdateComponent } from '../orderaddupdate/orderaddupdate.component';
import { EditproductreviewComponent } from '../editproductreview/editproductreview.component';
import { OrderattachmentComponent } from '../editproductreview/orderattachment/orderattachment.component';
import { OrderapprovepdfComponent } from '../editproductreview/orderapprovepdf/orderapprovepdf.component';
import { DetailsproductreviewComponent } from '../detailsproductreview/detailsproductreview.component';
import { DetailapprovepdfComponent } from '../detailsproductreview/detailapprovepdf/detailapprovepdf.component';
import { DetailattachmentComponent } from '../detailsproductreview/detailattachment/detailattachment.component';
import { SharedModule } from '../../../shared/shared.module';

@NgModule({
  declarations: [
    ProductviewlistComponent,
    OrderaddupdateComponent,
    EditproductreviewComponent,
    OrderattachmentComponent,
    OrderapprovepdfComponent,
    DetailsproductreviewComponent,
    DetailapprovepdfComponent,
    DetailattachmentComponent
  ],
  imports: [
    OrderreviewRoutingModule,
    SharedModule
  ]
})
export class OrderreviewModule {}
